// Fixed-point helpers. One tile is TILE units. Every value in the sim is an
// integer. JavaScript numbers are doubles, which represent integers exactly
// below 2^53, and integer add/sub/mul of such values is deterministic on
// every engine. The rules: never let a non-integer survive, and keep
// intermediates below 2^53.

export const TILE = 1024;
export const TICKS_PER_SECOND = 20;
export const MAP_SIZE = 64;

/** Integer square root (floor). n must be a non-negative integer. */
export function isqrt(n: number): number {
  if (n <= 0) return 0;
  let x = n;
  let y = Math.floor((x + 1) / 2);
  while (y < x) {
    x = y;
    y = Math.floor((x + Math.floor(n / x)) / 2);
  }
  return x;
}

/** Euclidean distance between two points in units, floored. */
export function dist(ax: number, ay: number, bx: number, by: number): number {
  const dx = ax - bx;
  const dy = ay - by;
  return isqrt(dx * dx + dy * dy);
}

/** Distance from a point to the nearest point of an axis-aligned rect. */
export function distToRect(
  px: number, py: number,
  rx: number, ry: number, rw: number, rh: number,
): number {
  const cx = px < rx ? rx : px > rx + rw ? rx + rw : px;
  const cy = py < ry ? ry : py > ry + rh ? ry + rh : py;
  return dist(px, py, cx, cy);
}

export function tileOf(units: number): number {
  return Math.floor(units / TILE);
}

export function centerOfTile(tile: number): number {
  return tile * TILE + TILE / 2;
}
